import React, { useRef, useState } from "react";
import { FeatureGroup, Polygon, GeoJSON } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import L from "leaflet";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw";
import { reverseGeocodeWithNominatim } from "api/map";
import { getPolygonCentroid } from "utils/commonUtils";
import milanBoundary from "../milan_coordinates.json";
import locations from "../locations.json";

const DrawMap = ({ onLocationSelect, onLocationRemove }) => {
  const drawControlRef = useRef(null);
  const featureGroupRef = useRef(null);
  const closeButtonMarkers = useRef([]);

  const _onCreated = async (e) => {
    let layer = e.layer;
    let layerId;

    if (layer instanceof L.Circle) {
      const center = layer.getLatLng();
      const radius = layer.getRadius();
      const numSides = 32;
      const latlngs = [];
      layerId = layer._leaflet_id;

      for (let i = 0; i < numSides; i++) {
        const angle = (i / numSides) * (2 * Math.PI);
        const lat = center.lat + (radius / 111320) * Math.sin(angle);
        const lng =
          center.lng +
          (radius / (111320 * Math.cos(center.lat * (Math.PI / 180)))) *
            Math.cos(angle);
        latlngs.push([lat, lng]);
      }

      latlngs.push(latlngs[0]);

      layer = L.polygon(latlngs);
    } else if (layer instanceof L.Polygon) {
      const latlngs = layer.getLatLngs()[0];

      const startPoint = latlngs[0];

      const closeButtonIcon = L.divIcon({
        className: "close-button-icon",
        html: `<div class="close-icon"></div>`,
        iconAnchor: [12, 12],
      });

      const startMarker = L.marker(startPoint, {
        icon: closeButtonIcon,
        interactive: true,
      }).addTo(featureGroupRef.current);

      closeButtonMarkers.current.push(startMarker);

      layerId = layer._leaflet_id;

      const handleClosePolygon = () => {
        layer.remove();
        startMarker.remove();

        onLocationRemove(layerId);

        const drawControl = drawControlRef.current;
        const polygonTool = drawControl._toolbars.draw._modes.polygon.handler;
        if (polygonTool) {
          polygonTool.enable();
        }
      };

      startMarker.on("click", handleClosePolygon);
    }

    const geoJsonData = layer.toGeoJSON();

    const latlngs = layer.getLatLngs()[0];
    const centroid = getPolygonCentroid(latlngs);
    const { lat, lng } = centroid;

    const locationData = await reverseGeocodeWithNominatim(lat, lng);

    geoJsonData.properties.FID_1 = layerId;
    geoJsonData.properties.NIL = locationData.suburb;
    geoJsonData.properties.City = locationData.city;

    onLocationSelect(geoJsonData);
  };

  const _onMounted = (drawControl) => {
    drawControlRef.current = drawControl;

    const polygonTool = drawControl._toolbars.draw._modes.polygon.handler;

    if (polygonTool) {
      polygonTool.enable();
    }
  };

  const _onDrawStart = () => {
    if (featureGroupRef.current) {
      featureGroupRef.current.clearLayers();
    }
    // Clear previous close buttons
    closeButtonMarkers.current.forEach((marker) => marker.remove());
    closeButtonMarkers.current = [];
  };

  const _onDrawVertex = (e) => {
    const layers = e.layers.getLayers();
    if (layers.length >= 3) {
      const firstMarkerElement = document.querySelector(
        `.leaflet-marker-icon.leaflet-div-icon`
      );
      if (firstMarkerElement) {
        firstMarkerElement.style.backgroundColor = "red";
        firstMarkerElement.style.borderColor = "red";
      }
    }
  };

  const modifiedCoordinates = milanBoundary.map((coord) => [
    coord[1],
    coord[0],
  ]);

  return (
    <>
      {/* <Polygon positions={modifiedCoordinates} color="blue" fillOpacity={0.1} /> */}

      <GeoJSON data={locations.features} />

      <FeatureGroup ref={featureGroupRef}>
        <EditControl
          ref={drawControlRef}
          position="topright"
          onCreated={_onCreated}
          onMounted={_onMounted}
          onDrawStart={_onDrawStart}
          onDrawVertex={_onDrawVertex}
          draw={{
            marker: false,
            polyline: false,
            rectangle: false,
            circlemarker: false,
            circle: true,
            polygon: true,
          }}
          edit={{
            edit: false,
            remove: false,
          }}
        />
      </FeatureGroup>
    </>
  );
};

export default DrawMap;

// import React, { useRef } from "react";
// import { MapContainer, TileLayer, FeatureGroup, Polygon } from "react-leaflet";
// import { EditControl } from "react-leaflet-draw";
// import L from "leaflet";
// import "leaflet-draw/dist/leaflet.draw.css";

// const milanBoundary = [
//   [45.464211, 9.190953],
//   [45.482123, 9.174456],
//   // Add more coordinates to outline Milan's boundary
// ];

// const DrawMap = ({ onLocationSelect, onLocationRemove }) => {
//   const drawControlRef = useRef(null);
//   const featureGroupRef = useRef(null);
//   const closeButtonMarkers = useRef([]);

//   const isWithinMilan = (latLngs) => {
//     const polygon = L.polygon(milanBoundary);
//     return polygon.getBounds().contains(L.latLng(latLngs[0]));
//   };

//   const _onCreated = async (e) => {
//     const layer = e.layer;
//     const latlngs = layer.getLatLngs()[0];

//     if (!isWithinMilan(latlngs)) {
//       alert("Please draw within the Milan city boundary.");
//       layer.remove();
//       return;
//     }

//     // Continue with your existing logic...
//   };

//   const _onDrawStart = () => {
//     // Clear layers and close buttons logic...
//   };

//   return (
//     <MapContainer center={[45.464211, 9.190953]} zoom={13} style={{ height: "100vh" }}>
//       <TileLayer
//         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//         attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//       />
//       <Polygon positions={milanBoundary} color="blue" fillOpacity={0.1} />
//       <FeatureGroup ref={featureGroupRef}>
//         <EditControl
//           ref={drawControlRef}
//           position="topright"
//           onCreated={_onCreated}
//           onDrawStart={_onDrawStart}
//           draw={{
//             marker: false,
//             polyline: false,
//             rectangle: false,
//             circlemarker: false,
//             circle: true,
//             polygon: true,
//           }}
//           edit={{
//             edit: false,
//             remove: false,
//           }}
//         />
//       </FeatureGroup>
//     </MapContainer>
//   );
// };

// export default DrawMap;
